module.exports.translationExists = function(translation) {
    return translation.indexOf('Missing translation:') < 0
}
